"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const col_1 = require("./col");
const row_1 = require("./row");
require("@hotmart/cosmos/dist/grid/grid.css");
const GridView = ({ children, className, 'data-test': dataTest, fluid = false }) => {
    const classes = (0, classnames_1.default)({ 'hot-container-fluid': fluid, 'hot-container': !fluid }, className);
    return ((0, jsx_runtime_1.jsx)("div", { "data-test": dataTest, className: classes, children: children }));
};
GridView.Row = row_1.Row;
GridView.Col = col_1.Col;
exports.default = GridView;
